import React, { useEffect, useState } from "react";
import "./Filter_Offcanvas.css";
import { Accordion, Form, Offcanvas } from "react-bootstrap";
import { Slider } from "@mui/material";
import Blue_Btn from "../../common_components/common_btn/Blue_Btn/Blue_Btn";
import { useDispatch, useSelector } from "react-redux";
import {
  getheight,
  getMatressfeel,
  getSize,
} from "../../../features/home/homeSlice";

const Filter_Offcanvas = ({
  show,
  onHide,
  selectedOption,
  setSelectedOption,
  activeSize,
  setActiveSize,
  setActiveHeight,
  activeHeight,
  activeMattress,
  setActiveMattress,
  onFilterChange,

  priceRange,
  setPriceRange,
  setDiscount,
  discount,
  ...props
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getMatressfeel());
    dispatch(getSize());
    dispatch(getheight());
  }, [dispatch]);
  const highlowprice = useSelector((state) => state.master.high_low_price);
  const matress = useSelector((state) => state?.home?.mattressfeel);
  const size = useSelector((state) => state?.home?.size);
  const height = useSelector((state) => state?.home?.height);

  const [activeDiscount, setActiveDiscount] = useState([]);

  const handleSelectSize = (id) => {
    setActiveSize(
      (prev) =>
        prev.includes(id)
          ? prev.filter((item) => item !== id) // REMOVE if already selected
          : [...prev, id], // ADD if not selected
    );
  };

  const handleSelectMattress = (id) => {
    setActiveMattress(
      (prev) =>
        prev.includes(id)
          ? prev.filter((item) => item !== id) // REMOVE if already selected
          : [...prev, id], // ADD if not selected
    );
  };
  const handleSelectHeight = (id) => {
    setActiveHeight(
      (prev) =>
        prev.includes(id)
          ? prev.filter((item) => item !== id) // REMOVE if already selected
          : [...prev, id], // ADD if not selected
    );
  };

  const handleSelectDiscount = (val) => {
    // const discountRange = `${val.min},${val.max}`;

    // setActiveDiscount(val?.id);
    // setDiscount(discountRange);

    if (activeDiscount === val.id) {
      // ✅ deselect
      setActiveDiscount(null);

      // reset API filter
      setDiscount("");
    } else {
      // ✅ select
      setActiveDiscount(val.id);

      // apply filter
      setDiscount(`${val.min},${val.max}`);
    }
  };

  const marks = [
    {
      value: Number(highlowprice?.lowest_price),
      label: `₹ ${highlowprice?.lowest_price}`,
    },
    {
      value: Number(highlowprice?.highest_price),
      label: `₹ ${highlowprice?.highest_price}`,
    },
  ];
  // console.log(priceRange, "priceRange priceRange");

  const discountRanges = [
    { id: 1, label: "10% - 20%", min: 10, max: 20 },
    { id: 2, label: "20% - 40%", min: 20, max: 40 },
    { id: 3, label: "40% - 60%", min: 40, max: 60 },
    { id: 4, label: "60% - 90%", min: 60, max: 90 },
    { id: 5, label: "90% - 100%", min: 90, max: 100 },
  ];

  const handleClearAll = () => {
    setDiscount([]);
    setActiveSize([]);
    setActiveHeight([]);
    setActiveMattress([]);
    setPriceRange([
      Number(highlowprice?.lowest_price) || 0,
      Number(highlowprice?.highest_price) || 0,
    ]);
    onHide();
  };

  return (
    <Offcanvas
      show={show}
      onHide={onHide}
      className="sort_offcanvas Filter_By_Offcanvas"
      placement="end"
    >
      <Offcanvas.Header>
        <div className="logo_div">
          <img
            src={process.env.PUBLIC_URL + "/assets/images/logo/logo.png"}
            className="logo"
          />
        </div>
        <div className="close_div" onClick={onHide}>
          <img
            src="/assets/images/icons/close_white.png"
            className="close_img"
          />
        </div>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <div className="filter_div">
          <Form className="form-holder">
            <div className="input_container">
              <p className="section_title">Price Range</p>
              <div className="slider_div">
                <Slider
                  min={Number(highlowprice?.lowest_price)}
                  max={Number(highlowprice?.highest_price)}
                  value={priceRange}
                  onChange={(e, newValue) => setPriceRange(newValue)}
                  // defaultValue={1000}
                  marks={marks}
                  step={500}
                  valueLabelDisplay="auto"
                  valueLabelFormat={(value) => `₹ ${value.toLocaleString()}`}
                />
              </div>
            </div>

            <div className="input_container accordion_div">
              <Accordion className="info_accordion">
                <Accordion.Item eventKey="1">
                  <Accordion.Header>Type</Accordion.Header>
                  <Accordion.Body>
                    <div className="accordBodycontent">
                      {size?.map((val) => (
                        <p
                          key={val.id}
                          className={
                            activeSize?.includes(val.id) ? "active" : ""
                          }
                          onClick={() => handleSelectSize(val.id)}
                        >
                          <Form.Check
                            type="checkbox"
                            checked={activeSize?.includes(val.id)}
                          />{" "}
                          {val?.name}
                        </p>
                      ))}
                    </div>
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="2">
                  <Accordion.Header>Mattress Feel</Accordion.Header>
                  <Accordion.Body>
                    <div className="accordBodycontent">
                      {matress?.map((val) => (
                        <p
                          key={val.id}
                          className={
                            activeMattress?.includes(val.id) ? "active" : ""
                          }
                          onClick={() => handleSelectMattress(val.id)}
                        >
                          <Form.Check
                            type="checkbox"
                            checked={activeMattress?.includes(val.id)}
                            readOnly
                          />{" "}
                          {val?.name}
                        </p>
                      ))}
                    </div>
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="3">
                  <Accordion.Header>Size</Accordion.Header>
                  <Accordion.Body>
                    <div className="accordBodycontent">
                      {height?.map((val) => (
                        <p
                          key={val.id}
                          className={
                            activeHeight?.includes(val.id) ? "active" : ""
                          }
                          onClick={() => handleSelectHeight(val.id)}
                        >
                          <Form.Check
                            type="checkbox"
                            checked={activeHeight?.includes(val.id)}
                          />{" "}
                          {val?.name}
                        </p>
                      ))}
                    </div>
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="4">
                  <Accordion.Header>Discount</Accordion.Header>
                  <Accordion.Body>
                    <div className="accordBodycontent">
                      {discountRanges?.map((val) => (
                        <p
                          key={val.id}
                          className={activeDiscount === val.id ? "active" : ""}
                          onClick={() => handleSelectDiscount(val)}
                        >
                          <Form.Check
                            type="checkbox"
                            checked={activeDiscount === val.id}
                          />{" "}
                          {val?.label}
                        </p>
                      ))}
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </Form>
        </div>

        <div className="clear_btn">
          <Blue_Btn btnText={"CLEAR ALL"} onClick={handleClearAll} />
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default Filter_Offcanvas;

// import React, { useEffect, useState } from "react";
// import "./Filter_Offcanvas.css";
// import { Accordion, Form, Offcanvas } from "react-bootstrap";
// import { Slider } from "@mui/material";
// import Blue_Btn from "../../common_components/common_btn/Blue_Btn/Blue_Btn";
// import { useDispatch, useSelector } from "react-redux";
// import { getheight, getMatressfeel, getSize } from "../../../features/home/homeSlice";
// const Filter_Offcanvas = ({
//   show,
//   onHide,
//   selectedOption,
//   setSelectedOption,
//   softTypeId,
//   setSoftTypeId,
//   metalId,
//   setMetalId,
//   sizeId,
//   setSizeId,
//   discountMin,
//   setDiscountMin,
//   discountMax,
//   setDiscountMax,
//   ...props
// }) => {
//   const handleOptionChange = (event) => {
//     setSelectedOption(event.target.value);
//     onHide();
//   };

//   const marks = [
//     { value: 500, label: "₹ 500" },
//     { value: 50000, label: "₹ 50,000" },
//   ];

//   const brand = [
//     { id: 1, label: "10% - 20%" },
//     { id: 2, label: "20% - 40%" },
//     { id: 3, label: "40% - 60%" },
//     { id: 4, label: "60% - 90%" },
//     { id: 5, label: "90% - 100%" },
//   ];

//   const [value, setValue] = useState();
//   const [isActiveBrand, setIsActiveBrand] = useState(null);
//   const handleClickBrand = (id) => setIsActiveBrand(id);

//   const matress = useSelector((state) => state?.home?.mattressfeel);
//   const size = useSelector((state) => state?.home?.size);
//   const height = useSelector((state) => state?.home?.height);

//   const dispatch = useDispatch();
//   useEffect(() => {
//     dispatch(getMatressfeel());
//     dispatch(getSize());
//     dispatch(getheight());
//   }, []);

//   return (
//     <Offcanvas
//       show={show}
//       onHide={onHide}
//       className="sort_offcanvas Filter_By_Offcanvas"
//       placement="end"
//     >
//       <Offcanvas.Header>
//         <div className="logo_div">
//           <img
//             src={process.env.PUBLIC_URL + "/assets/images/logo/logo.png"}
//             className="logo"
//           />
//         </div>
//         <div className="close_div" onClick={onHide}>
//           <img
//             src="/assets/images/icons/close_white.png"
//             className="close_img"
//           />
//         </div>
//       </Offcanvas.Header>
//       <Offcanvas.Body>
//         <div className="filter_div">
//           <Form className="form-holder">
//             <div className="input_container">
//               <p className="section_title">Price Range</p>

//               <div className="slider_div">
//                 <Slider
//                   min={500}
//                   max={50000}
//                   defaultValue={1000}
//                   marks={marks}
//                   step={500}
//                   valueLabelDisplay="auto"
//                   valueLabelFormat={(value) => `₹ ${value.toLocaleString()}`}
//                 />
//               </div>
//             </div>

//             <div className="input_container accordion_div">
//               <Accordion className="info_accordion">
//                 <Accordion.Item eventKey="1">
//                   <Accordion.Header>Size</Accordion.Header>
//                   <Accordion.Body>
//                     <div className="accordBodycontent">
//                       {size?.map((val, index) => (
//                         <p
//                           className={isActiveBrand === val.id ? "active" : ""}
//                           onClick={() => handleClickBrand(val.id)}
//                         >
//                           <Form.Check type="checkbox" /> {val?.name}
//                         </p>
//                       ))}
//                     </div>
//                   </Accordion.Body>
//                 </Accordion.Item>

//                 <Accordion.Item eventKey="2">
//                   <Accordion.Header>Mattress Feel</Accordion.Header>
//                   <Accordion.Body>
//                     <div className="accordBodycontent">
//                       {matress?.map((val, index) => (
//                         <p
//                           className={isActiveBrand === val.id ? "active" : ""}
//                           onClick={() => handleClickBrand(val.id)}
//                         >
//                           <Form.Check type="checkbox" /> {val?.name}
//                         </p>
//                       ))}
//                     </div>
//                   </Accordion.Body>
//                 </Accordion.Item>

//                 <Accordion.Item eventKey="3">
//                   <Accordion.Header>Height</Accordion.Header>
//                   <Accordion.Body>
//                     <div className="accordBodycontent">
//                       {height?.map((val, index) => (
//                         <p
//                           className={isActiveBrand === val.id ? "active" : ""}
//                           onClick={() => handleClickBrand(val.id)}
//                         >
//                           <Form.Check type="checkbox" /> {val?.name}
//                         </p>
//                       ))}
//                     </div>
//                   </Accordion.Body>
//                 </Accordion.Item>

//                 <Accordion.Item eventKey="4">
//                   <Accordion.Header>Discount</Accordion.Header>
//                   <Accordion.Body>
//                     <div className="accordBodycontent">
//                       {brand?.map((val, index) => (
//                         <p
//                           className={isActiveBrand === val.id ? "active" : ""}
//                           onClick={() => handleClickBrand(val.id)}
//                         >
//                           <Form.Check type="checkbox" /> {val?.label}
//                         </p>
//                       ))}
//                     </div>
//                   </Accordion.Body>
//                 </Accordion.Item>
//               </Accordion>
//             </div>
//           </Form>
//         </div>

//         <div className="clear_btn">
//           <Blue_Btn btnText={"CLEAR ALL"} />
//         </div>
//       </Offcanvas.Body>
//     </Offcanvas>
//   );
// };
// export default Filter_Offcanvas;
